import { render, staticRenderFns } from "./Section10.vue?vue&type=template&id=ed1872f8&scoped=true"
import script from "./Section10.vue?vue&type=script&lang=js"
export * from "./Section10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1872f8",
  null
  
)

export default component.exports